import React from "react"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import maintenance from "../assets/maintenance.png"
import unavailablePage from "../assets/unavailablePage.json"

function Maintenance({ error }) {
  const { code: errorCode, message: maintenanceMessage } = error
  const { title, text } = unavailablePage[errorCode]
  let message = maintenanceMessage || text
  if (!/^#+/.test(message)) {
    message = `#### ${message}`
  }
  return (
    <div className="unavailable-page-container">
      <div className="unavailable-container">
        <img src={maintenance} alt="Maintenance" className="maintenance-img" />
        <div className="text-container">
          <h2 className="title"> {title} </h2>
          <br />
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{message}</ReactMarkdown>
        </div>
      </div>
    </div>
  )
}

export default Maintenance
